export default {

All:"الكل",
Vegetables:"الخضروات",
Fruits:"الفواكه",
Fresh:"طازج",
Meat:"اللحوم",
Dairy:"الألبان",
Bakery:"المخبوزات",
Beverages:"المشروبات",

categories:"الفئات",
size:"الحجم",
priceRange:"نطاق السعر",
filterByVendor:"تصفية حسب المورد",
deliveryTrust:"التوصيل والثقة",
sameDayDelivery:"توصيل في نفس اليوم",
verifiedSuppliers:"موردون موثوقون",
resetFilters:"إعادة ضبط الفلاتر",
selectStore:"اختر عنوان المتجر",
Kg:"كجم",
Liter:"لتر",
Piece:"قطعة",
Box:"صندوق",

viewProduct:"عرض المنتج",

minutes:"دقيقة",

buy:"اشتر",
get:"واحصل",
off:"خصم",

qar:"ر.ق",

  "free_delivery": "توصيل مجاني في جميع أنحاء قطر",
  "verified_suppliers": "موردون موثوقون 100٪",
  "fast_processing": "معالجة الطلبات بسرعة",
  "download_app": "تحميل تطبيق محل للجوال"

}